export class LivePlayerStatistic {
    id: number;
    nId: number;
    yellowCards: number = 0;
    playerId: number;
    goals: number = 0;
    shotsOnGoal: number = 0;
    shotsTotal: number = 0;
    passesTotal: number = 0;
    passesAccurate: string;
    assists: number = 0;
    goalsConceded: number = 0;
    foulsDrawn: number = 0;
    offSides: number = 0;
    crossesTotal: number = 0;
    crossesAccurate: number = 0;
    foulsCommitted: number = 0;
    tackles: number = 0;
    blocks: number = 0;
    interceptions: number = 0;
    clearances: number = 0;
    saves: number = 0;
    penaltyScore: number = 0;
    penaltyMissed: number = 0;
    penaltySaved: number = 0;
    minutesPlayed: number = 0;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/live-player-statistic.model.ts